import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Logger, LoggingService } from 'ionic-logging-service';
import { Observable } from 'rxjs';
import { delay, finalize, retryWhen, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  public  authWaiting: boolean = false;
  public  errorMessage: string = null;
  private logger: Logger;
  public  loginFailed: string = null;
  public  recoveringPassword: boolean = false;
  private httpErrorResponse: HttpErrorResponse;

  constructor(
    private httpClient: HttpClient,
    private loggingService: LoggingService,

  ) {
    this.logger = this.loggingService.getLogger("[HttpService]");
    const methodName = "ctor";
    this.logger.entry(methodName);
  }

  public httpRequestGET(url, component, method): Observable<any> {
    return new Observable((observer) => {
        this.httpClient.get<any>(url)
        .pipe(retryWhen(error => error.pipe(
            delay(1000),
            take(3),
            // return httpErrorResponse.status > 499 ? Observable.of(true) : Observable.throw(httpErrorResponse);
            tap((httpErrorResponse: HttpErrorResponse) => {this.httpErrorResponse = httpErrorResponse}),
            finalize(() => {
                observer.error(this.httpErrorResponse);
                observer.complete();
            })
        )))
        .subscribe((res: any) => {
            observer.next(res);
            observer.complete();
        });
    });
  }

  public httpRequestPOST(url, params, component, method, headers?): Observable<any> {
    return new Observable((observer) => {
        this.httpClient.post<any>(url, params, headers ? headers : '')
        .pipe(retryWhen(error => error.pipe(
            delay(1000),
            take(3),
            // return httpErrorResponse.status > 499 ? Observable.of(true) : Observable.throw(httpErrorResponse);
            tap((httpErrorResponse: HttpErrorResponse) => {this.httpErrorResponse = httpErrorResponse}),
            finalize(() => {
                observer.error(this.httpErrorResponse);
                observer.complete();
            })
        )))
        .subscribe((res: any) => {
            observer.next(res);
            observer.complete();
        });
    });
  }
}